import { getDateFilterEndDate } from '@griply/utils';
import React, { useMemo } from 'react';
import { rootId } from 'shared/components/ui/virtualized-tree-list';
import { useToday } from 'shared/contexts/today';

import { useDeadlineTree } from '../../hooks/use-deadline-tree';
import { useGoalDeadlineRows } from '../../hooks/use-goal-deadline-rows';
import { GroupedListProps } from '../../types';
import { MultipleDeadlinesGroupTaskList } from './multiple-deadlines-group-task-list';
import { SingleDeadlineGroupTaskList } from './single-deadline-group-task-list';

// todo: extract the spitsing of groups to a new grouping specifically for today

export const DeadlineGroupingTasksList: React.FC<GroupedListProps> = ({
  tasks,
  goals,
  lifeAreas,
  sortingMode,
  onReorder,
  customOrder = {},
  collapsedSections = [],
  onSectionCollapse,
  weekStartsOn,
  scrollElement,
  denseFormat,
  groupSettings,
  filterDocument,
  isContextMenuOpen,
  defaultNewTaskDate,
}) => {
  const today = useToday();

  const dateFilterEndDate = useMemo(
    () => getDateFilterEndDate(filterDocument),
    [filterDocument],
  );

  const { deadlineGoals, goalRows: goalRenderData } = useGoalDeadlineRows({
    goals,
    lifeAreas,
    filterDocument,
    showCompleted: !!filterDocument?.showCompleted,
    enabled: groupSettings?.showGoalDeadlines,
  });

  const treeData = useDeadlineTree({
    tasks,
    customOrder,
    sortingMode,
    today,
    weekStartsOn,
    showEmptyOverdue:
      groupSettings?.showEmptyGroups || groupSettings.showEmptyOverdue,
    showEmptyNoDate:
      groupSettings?.showEmptyGroups || groupSettings.showEmptyNoDate,
    showEmptyDate:
      groupSettings?.showEmptyGroups || groupSettings.showEmptyDate,
    dateFilterEndDate,
    hideNewTaskRow: groupSettings.hideNewTaskRow,
    deadlineGoals,
  });

  if (
    groupSettings.showSingleDeadlineAsNoGrouping &&
    treeData[rootId].children?.length === 1
  ) {
    return (
      <SingleDeadlineGroupTaskList
        treeData={treeData}
        tasks={tasks}
        onReorder={onReorder}
        weekStartsOn={weekStartsOn}
        collapsedSections={collapsedSections}
        onSectionCollapse={onSectionCollapse}
        scrollElement={scrollElement}
        denseFormat={denseFormat}
        isContextMenuOpen={isContextMenuOpen}
        defaultNewTaskDate={defaultNewTaskDate}
        goalId={groupSettings.goalId}
        lifeAreaId={groupSettings.lifeAreaId}
        tagId={groupSettings.tagId}
        displayDue={groupSettings.displayDue}
        showRepeatingAsTodo={groupSettings.showRepeatingAsTodo}
        goalRenderData={goalRenderData}
      />
    );
  }

  return (
    <MultipleDeadlinesGroupTaskList
      treeData={treeData}
      tasks={tasks}
      onReorder={onReorder}
      weekStartsOn={weekStartsOn}
      collapsedSections={collapsedSections}
      onSectionCollapse={onSectionCollapse}
      scrollElement={scrollElement}
      denseFormat={denseFormat}
      isContextMenuOpen={isContextMenuOpen}
      defaultNewTaskDate={defaultNewTaskDate}
      goalId={groupSettings.goalId}
      lifeAreaId={groupSettings.lifeAreaId}
      tagId={groupSettings.tagId}
      displayDue={groupSettings.displayDue}
      showRepeatingAsTodo={groupSettings.showRepeatingAsTodo}
      goalRenderData={goalRenderData}
    />
  );
};
